/*
 * ****************************************************************************
 * Copyright (C) 2018-2018, All rights reserved.
 * Project: chessmate
 * Created On: March 23rd, 2018
 * Last Modified: March 23rd, 2018
 * ****************************************************************************
 */

import * as React from 'react';
import * as Mui from 'mui';
import { BarButton, PopupMenuItem, PopupMenu } from 'components';
import { GameStateContext, GameState } from 'contexts/gameStateContext';

/** GameControlBarProps - Properties */
export interface GameControlBarProps {
  leftMargin: number;
  boardWidth: number;
  optionsMenu?: PopupMenuItem[];
}

export interface GameControlBarState {
  showPaste: boolean;
}

/** GameControlBar */
export class GameControlBar extends React.Component<GameControlBarProps, GameControlBarState> {
  constructor(props: GameControlBarProps, ctx: any) {
    super(props, ctx);
    this.state = {
      showPaste: false
    };
  }

  first(game: GameState) {
    game.moveToPosition(0);
  }
  prev(game: GameState) {
    game.moveToPosition(game.position - 1);
  }
  next(game: GameState) {
    game.moveToPosition(game.position + 1);
  }
  last(game: GameState) {
    game.moveToPosition(game.lastPosition);
  }

  render() {

    const { leftMargin, boardWidth } = this.props;

    return (
      <GameStateContext>{game => (
        <Mui.AppBar className="chessbar-horz chessbar-top" position="static">
          <Mui.Toolbar variant="dense" disableGutters>
            <div className="flex fill row no-wrap left">
              <div style={{ flexBasis: `${boardWidth + leftMargin}px` }}>
                <div className="normal">
                  {!this.props.optionsMenu && (<BarButton icon="settings" text="Options" disabled />)}
                  {!!this.props.optionsMenu && (<PopupMenu icon="settings" text="Options" noDownArrow items={this.props.optionsMenu} />)}
                </div>
              </div>
              <div className="fill center">
                <BarButton icon="first_page" onClick={e => this.first(game)} disabled={game.position === 0} />
                <BarButton icon="navigate_before" onClick={e => this.prev(game)} disabled={game.position === 0} />
                <BarButton icon="navigate_next" onClick={e => this.next(game)} disabled={game.position === game.lastPosition} />
                <BarButton icon="last_page" onClick={e => this.last(game)} disabled={game.position === game.lastPosition} />
              </div>
            </div>
          </Mui.Toolbar>
          <Mui.Dialog open={!!this.state.showPaste} onClose={() => this.setState({ showPaste: false })}>
            <textarea>(paste here)</textarea>
            <button>Save</button>
          </Mui.Dialog>
        </Mui.AppBar>
      )}</GameStateContext>
    );
  }
}

export default GameControlBar;


// WEBPACK FOOTER //
// ./src/views/playChess/components/gameControlBar.tsx